<template>
  <footer>
    <div class="footer-menus">
      <div class="contact-us">
        <!-- <p class="menu-title">お問い合わせ</p> -->
        <p>住所: 〒103-0022 東京都中央区日本橋室町1丁目11番12号日本橋水野ビル7階</p>
        <p>電話：090-4360-1035</p>
        <p>メール：info@stt-it.com</p>
      </div>
    </div>
    <p class="rights">&copy; 2025 STT株式会社</p>
    <div class="scroll-to-top">
      <a href="#home"><i class="fa fa-chevron-up"></i></a>
    </div>
  </footer>
</template>

<script setup>
</script>

<style scoped>
/* 你原来的 footer 样式可以复制进来 */
</style>
